import { BDCPFolder } from '../../../../models/folder.model';
import { BDModalComponent } from '@brother-apps/brother-dealerapp-shared-lib';

export abstract class IBDCPFolderService {

    folders: BDCPFolder[];

    abstract getAll(): Promise<BDCPFolder[]>;
    abstract get(folderId: number, includeProducts?: boolean): Promise<BDCPFolder>;
    abstract create(name: string): Promise<BDCPFolder>;
    abstract update(folderId: number, name: string): Promise<void>;
    abstract duplicate(folderId: number): Promise<void>;
    abstract delete(folderId: number): Promise<void>;
    abstract addProduct(folderId: number): Promise<void>;
    abstract deleteProduct(folderId: number, sku: string): Promise<void>;

    abstract init(modal: BDModalComponent): void;
    abstract open(sku: string): void;
    abstract close(): void;
}
